import cxs from 'cxs';

export const LIST_PLACEHOLDER = cxs({
  width: '100%',
  height: '130px',
  overflow: 'hidden'
});

export const GRID_PLACEHOLDER = cxs({
  backgroundColor: '#fff',
  width: 'auto',
  overflow: 'hidden'
});